var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxHeight = exports.lineHeights = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _styledSystem = require("@sport1/styled-system");

var lineHeights = function lineHeights(props) {
  switch (props.size) {
    case 'small':
      return "\n              line-height: " + (0, _styledSystem.themeGet)('lineHeights.3', '16px')(props) + ";\n          ";

    case 'medium':
      return "\n              line-height: " + (0, _styledSystem.themeGet)('lineHeights.2', '20px')(props) + ";\n          ";

    case 'large':
      return "\n              line-height: " + (0, _styledSystem.themeGet)('lineHeights.1', '24px')(props) + ";\n          ";

    case 'largest':
      return "\n              line-height: " + (0, _styledSystem.themeGet)('lineHeights.0', '40px')(props) + ";\n          ";

    case 'arrowSize':
      return "\n              line-height: " + (0, _styledSystem.themeGet)('arrowSize', '28px')(props) + ";\n          ";

    default:
      return '';
  }
};

exports.lineHeights = lineHeights;

var getMaxHeightForLineHeight = function getMaxHeightForLineHeight(lineHeight, numberOfLines, theme) {
  var maxHeight;

  if (typeof lineHeight === 'string') {
    maxHeight = parseInt(lineHeight.replace('line-height: ', '')) * numberOfLines;
  } else {
    var height = (0, _get.default)(theme, "lineHeights[" + lineHeight + "]", lineHeight);

    if (typeof height === 'string') {
      height = parseInt(height);
    }

    maxHeight = height * numberOfLines;
  }

  return maxHeight;
};

var getMaxHeight = function getMaxHeight(props) {
  var lineHeight = props.lineHeight,
      numberOfLines = props.numberOfLines,
      theme = props.theme;
  var lineHeightValue = lineHeight || lineHeights(props);

  if (Array.isArray(lineHeightValue)) {
    return lineHeightValue.map(function (height) {
      return getMaxHeightForLineHeight(height, numberOfLines, theme);
    });
  }

  return getMaxHeightForLineHeight(lineHeightValue, numberOfLines, theme);
};

exports.getMaxHeight = getMaxHeight;